import { Grid, Typography } from "@material-ui/core";
import { Field } from "react-final-form";
import styled from "styled-components";

export const StyledField = styled(Field)`
  background: #f5f5f5;
  width: 100%;
  display: flex;
  align-items: center;
  padding-left: 16px;
  margin-top: 5px;
  border-radius: 4px;
  font-size: 16px;
  height: 60px;
  div {
    flex-grow: 1;
  }
`;

export const StyledTextAreaField = styled(Field)`
  background: #f5f5f5;
  width: 100%;
  display: flex;
  padding-left: 8px;
  margin-top: 5px;
  border-radius: 4px;
  font-size: 16px;
`;

export const StyledGrid = styled(Grid)`
  display: flex;
  flex-direction: column;
`;

export const StyledLabel = styled(Typography)`
  color: #757575;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  font-size: 16px;
`;

export const StyledHelperText = styled(Typography)`
  color: #757575;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  font-size: 12px;
`;

export const HelperTextContainer = styled.section`
  display: flex;
  align-items: center;
  gap: 2px;
`;
